import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Input from "../../common/input";
import { Api } from "/api";
import styles from "./index.module.scss";
import Button from "../../common/button";
import { showPopup } from "../../../redux/action-creaters/popup";
import { popupTypes } from "../../../redux/reducers/popupReducer";

export default function AdminFeedback() {
  const [fields, setFields] = useState([
    {
      CODE: "NAME",
      NAME: "Имя",
      TYPE: "S",
      REQUIRED: true,
    },
    {
      CODE: "PAGE",
      NAME: "Страница с проблемой",
      TYPE: "S",
      REQUIRED: true,
    },
    {
      CODE: "BROWSER",
      NAME: "Браузер",
      TYPE: "S",
      REQUIRED: true,
    },
    {
      CODE: "DESCRIPTION",
      NAME: "Описание проблемы",
      TYPE: "HTML",
      REQUIRED: true,
    },
    {
      CODE: "CONTACT",
      NAME: "Как с вами связаться для уточнения деталей (телеграм / email)",
      TYPE: "S",
    },
    {
      CODE: "STEPS",
      NAME: "Шаги воспроизведения",
      TYPE: "HTML",
    },
    {
      CODE: "COMMENT",
      NAME: "Комментарий",
      TYPE: "HTML",
    },
  ]);
  const dispatch = useDispatch();
  const [result, setResult] = useState({});
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const { user } = useSelector((state) => state.user);

  const sentForm = async () => {
    if (
      !result.NAME ||
      !result.PAGE ||
      !result.BROWSER ||
      !result.DESCRIPTION
    ) {
      setError("Заполните все поля");
      return;
    }
    setError("");
    setIsProcessing(true);
    const data = await Api.server.sentFeedback(result);
    if (data.success) {
      setSuccess(`Проблема отправлена - решим в ближайщее время`);
    } else if (data.message) {
      setError(data.message);
      setFields(data.fields);
    }
    setIsProcessing(false);
  };

  useEffect(() => {
    setResult({
      ...result,
      NAME: `${user.NAME} #${user.ID}`,
      PAGE: window.location.href,
      BROWSER: window.navigator.appVersion,
    });
  }, []);

  return (
    <div>
      <h2>Сообщить о проблеме</h2>
      {success && (
        <>
          <span data-test="formSuccess">{success}</span>
          <div className={styles.Buttom}>
            <Button
              onClick={() => {
                dispatch(showPopup(popupTypes.none));
              }}
              label={"Закрыть"}
            />
          </div>
        </>
      )}
      {error && <span className={styles.Error}>{error}</span>}
      {!success && (
        <div className={styles.Items}>
          {fields.map(({ NAME, CODE, REQUIRED, ERROR, TYPE }) => (
            <Input
              key={CODE}
              value={result[CODE]}
              code={CODE}
              label={NAME}
              required={REQUIRED}
              onChange={(value) => setResult({ ...result, [CODE]: value })}
              isError={ERROR}
              isMultiple={TYPE === "HTML"}
            />
          ))}
        </div>
      )}
      {!success && (
        <div className={styles.Buttom}>
          <Button
            test="submitButton"
            onClick={() => sentForm()}
            isLoading={isProcessing}
            label={"Отправить"}
          />
        </div>
      )}
    </div>
  );
}
